import * as React from 'react';
import _ from 'lodash';
import { css, StyleSheet } from 'aphrodite';
import { utils } from 'ui-common';
import { WindowWrapper } from 'login-utils/globalWrappers';
import ArrowBackButton from '../ArrowBackButton/ArrowBackButton';
import { loginBackgroundDynamicColor } from 'login-stylesheets/deploymentColors';
import { fonts } from 'consumer-components';

const styles = StyleSheet.create({
  backButton: {
    ...fonts.Roboto,
    color: loginBackgroundDynamicColor,
    fontSize: 14,
  },
});

function goBackToPreviousApplication() {
  const previousSelectedProductId = utils.cookieUtils.get('previousSelectedProductId');
  if (!previousSelectedProductId) return;

  utils.cookieUtils.set('selectedProductId', previousSelectedProductId, { path: '/' });
  WindowWrapper.location.reload();
}

export default class BackToPreviousApplicationButton extends React.PureComponent {
  render() {
    return (
      <div className={css(styles.backButton)}>
        <ArrowBackButton onClick={goBackToPreviousApplication} />
      </div>
    );
  }
}
